module.exports = __webpack_public_path__ + "media/images/logos/rails-5ea26fb58364e7a7b4f27c150763fb55.svg";